import { useState } from "react";

export const usePdvCart = () => {
  const [cart, setCart] = useState([]);

  const addProduct = (p) => setCart((c) => {
    const ex = c.find((i) => i.product_id === p.id);
    if (ex) return c.map((i) => (i.product_id === p.id ? { ...i, quantity: Number(i.quantity) + 1 } : i));
    return [...c, { product_id: p.id, name: p.name, price: p.price, quantity: 1 }];
  });

  const addLinearLine = (p, meters, total) => setCart((c) => [...c, {
    product_id: p.id, line_id: `${p.id}-${Date.now()}`, name: `${p.name} (${meters} m)`,
    price: +(total / meters).toFixed(4), quantity: meters, linear: true,
  }]);

  const onDelta = (id, delta) => setCart((c) => c
    .map((i) => (i.product_id === id ? { ...i, quantity: Math.max(0, Number(i.quantity) + delta) } : i))
    .filter((i) => i.quantity > 0));

  const onQty = (id, value) => setCart((c) => c.map((i) => (i.product_id === id
    ? { ...i, quantity: value === "" ? "" : Math.max(0, Number(value)) } : i)));

  const onBlurQty = (id) => setCart((c) => c.map((i) => (i.product_id === id ? { ...i, quantity: Number(i.quantity) || 1 } : i)));

  const onRemove = (key) => setCart((c) => c.filter((i) => (i.line_id || i.product_id) !== key));

  const subtotal = cart.reduce((s, i) => s + i.price * (Number(i.quantity) || 0), 0);
  const payloadItems = () => cart.map((i) => ({
    product_id: i.product_id, name: i.name, price: i.price, quantity: Number(i.quantity),
  }));

  return { cart, setCart, addProduct, addLinearLine, subtotal, payloadItems, handlers: { onDelta, onQty, onBlurQty, onRemove } };
};
